import Swiper from "swiper/dist/js/swiper";

import ImageGallerySlide from "./imageGallerySlide";

import imageviewer from "./../templates/imagegallery.dust";

import {
  VIEW_IMAGE_GALLERY,
  OPENED_GALLERY_ALB,
  CLOSED_GALLERY_ALB,
  SWIPED_BACKWARD_GALLERY,
  SWIPED_FORWARD_GALLERY,
  CLICKED_NEXT_GALLERY,
  CLICKED_PREV_GALLERY,
  CLICKED_BULLET_GALLERY,
} from "./../analytics/analyticsevents";
import { noop } from "../utilities/utils";

export default class ImageGallery {
  appState = null;
  options = null;

  DOMContainer = null;
  context = null;
  swiper = null;

  slideNumber = null;

  lastIndex = null;
  nextBtnClicked = false;
  prevBtnClicked = false;
  loadedCallback = noop;
  loopSwiper = false;

  imageSlides = [];

  constructor({
    appState,
    slideNumber,
    context,
    options,
    loadedCallback = noop,
    loopSwiper = false,
  }) {
    this.appState = appState;
    this.DOMContainer = document.querySelector("#imageviewer");
    this.options = options;
    this.context = context;
    this.context.navigation =
      this.appState.isDesktop && context.images && context.images.length > 1;
    this.slideNumber = slideNumber;
    this.loadedCallback = loadedCallback;
    this.loopSwiper = loopSwiper;
    this.render();
  }

  createImageViewerSlide(image) {
    const slide = new ImageGallerySlide(this.appState, image, {
      ...this.options.imageviewerslide,
      loopSwiper: this.loopSwiper,
    });
    return slide;
  }

  addImages() {
    const resultPromise = new Promise((resolve, reject) => {
      const promiseData = {};
      promiseData.reject = reject;
      promiseData.resolve = resolve;
      const wrapper = this.DOMContainer.querySelector(
        ".swiper-wrapper-imageviewer"
      );
      const promises = [];
      if (wrapper) {
        this.context.images.forEach((image) => {
          image.singleImage = this.context.singleImage;
          const slide = this.createImageViewerSlide(image);
          this.imageSlides.push(slide);
          promises.push(slide.render());
        });
        Promise.all(promises).then((values) => {
          values.forEach((value) => {
            wrapper.appendChild(value);
          });
          promiseData.resolve(true);
        });
      }
    });
    return resultPromise;
  }

  render() {
    if (this.DOMContainer) {
      Dust.render(imageviewer, this.context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.addImages()
          .then(() => {
            // set swiper
            this.createSwiper();
            this.open();
          })
          .finally(() => {
            this.loadedCallback();
          });
      });
    }
  }

  createSwiper() {
    const selector = "#imageviewer .swiper-container-imageviewer";
    const a = document.querySelector(selector);
    if (a) {
      this.swiper = new Swiper($(a), {
        keyboardControl: true,
        initialSlide: this.slideNumber,
        centeredSlides: true,
        pagination: $(a).find(" .swiper-pagination-imageviewer"),
        paginationClickable: true,
        loop: this.loopSwiper,
        nextButton: $(a).find(" .swiper-button-next"),
        prevButton: $(a).find(" .swiper-button-prev"),
        onInit: () => {
          this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
        },
        onSlideNextEnd: () => {
          if (this.nextBtnClicked) {
            this.nextBtnClicked = false;
            this.appState.triggerEvent(CLICKED_NEXT_GALLERY);
          } else {
            this.appState.triggerEvent(SWIPED_FORWARD_GALLERY);
          }
          this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
        },
        onSlidePrevEnd: () => {
          if (this.prevBtnClicked) {
            this.prevBtnClicked = false;
            this.appState.triggerEvent(CLICKED_PREV_GALLERY);
          } else {
            this.appState.triggerEvent(SWIPED_BACKWARD_GALLERY);
          }
          this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
        },
        onTransitionEnd: ({ activeIndex }) => {
          // if active index is not 0, it is called in the beginning
          if (!this.appState.isDesktop) {
            this.imageSlides[activeIndex].renderHd();
          }
        },
      });
    }
  }

  initHammerSlide() {}

  open() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.remove("hidden");
      this.initHammerSlide();
      //pagination bug
      this.swiper.update();
      this.swiper.slideTo(this.slideNumber, 0);
      this.swiper.update();
      this.attatchClickHandlers();
      this.appState.triggerEvent(OPENED_GALLERY_ALB);
      document.addEventListener("keyup", this._onEscapeButtonKeyUp);
      this.appState.trigger("imageGallery:opened");
    }
  }

  close(e) {
    if (this.DOMContainer) {
      if (e.target.classList.contains("imageviewer-caption")) {
        return;
      }
      this.DOMContainer.innerHTML = "";
      this.context = null;
      this.swiper = null;
      this.imageSlides = null;
      this.DOMContainer.classList.add("hidden");
      const a = this.DOMContainer.querySelector(".swiper-wrapper-imageviewer");
      if (a) {
        a.removeEventListener("click", () => {
          this.close();
        });
      }
      this.removeListeners();
      this.DOMContainer = null;
      if (this.mc) {
        this.mc.destroy();
      }
      this.appState.triggerEvent(CLOSED_GALLERY_ALB);
      document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
      if (window.app && window.app.state) {
        // check if nextgen instance is there
        window.app.state.imageViewerClosed();
      }
      this.appState.trigger("imageGallery:closed");
    }
  }

  removeListeners() {}

  attatchClickHandlers() {
    const a = this.DOMContainer.querySelector(".swiper-wrapper-imageviewer");
    const viewerBullet = $(this.swiper.paginationContainer).find(
      ".swiper-pagination-bullet "
    );
    if (a) {
      a.addEventListener("click", (e) => {
        this.close(e);
      });
    }
    const close = this.DOMContainer.querySelector(".imageviewer-nav-back");
    if (close) {
      close.addEventListener("click", (e) => {
        this.close(e);
      });
    }

    $(this.swiper.nextButton).on("click", () => {
      this.nextBtnClicked = true;
    });

    $(this.swiper.prevButton).on("click", () => {
      this.prevBtnClicked = true;
    });

    $(viewerBullet).on("click", () => {
      this.appState.triggerEvent(CLICKED_BULLET_GALLERY);
    });
  }
  _onEscapeButtonKeyUp = (e) => {
    if (e.keyCode === 27) {
      this.close(e);
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/components/imageGallery.js